// Preact hook for subscribing components to the global app store.
// Per spec/tech-arch.md §3.1 + spec/build-plan.md P-020 row.
//
// **Whole-state form (D-082).** `useStore(): AppState` returns the entire
// AppState; per-screen narrowing happens via destructuring at the call
// site. Tech Arch §3.1 reads `useStore()` (no selector). Selector form
// gives more granular re-renders but adds API surface for negligible
// benefit at V1 scale (≤15 blocks per Email, all-form changes already
// debounced 50 ms at the preview engine seam, P-029).
//
// **Implementation.** Thin wrapper over `useSubscribed` (P-035 hoist
// at the 5th consumer per OC §3.3) — every subscribe-then-getValue
// hook in the project shares the same shape; one canonical
// implementation makes a future swap to `useSyncExternalStore` a
// single-file change.

import type { AppState } from '../../store/schemas'
import { useSubscribed } from '../../lib/use-subscribed'
import { store } from '../../store/store'

export function useStore(): AppState {
  return useSubscribed(store.getState, store.subscribe)
}
